<template lang='pug'>
  .heading-container
    .title(v-text='title')
    .description(v-if='!hideDescription' v-text='description')
</template>

<script>
export default {
  props: [
    'title',
    'description',
    'hideDescription'
  ]
}
</script>

<style lang='scss' scoped>
  .heading-container {
    width: 100%;

    @include media-breakpoint-up(xl) {
      order: 1;
      text-align: left;
      width: 300px;
    }

    > .title {
      @include font-sephora-serif;
      font-size: 30px;
      line-height: 32px;
      margin-left: auto;
      margin-right: auto;
      text-transform: uppercase;
      width: 80%;

      @include media-breakpoint-up(xl) {
        margin: 0;
        width: 290px;
      }
    }

    > .description {
      margin-left: auto;
      margin-right: auto;
      margin-top: 10px;
      width: 90%;
      font-size: 14px;

      @include media-breakpoint-up(xl) {
        margin-left: 0;
        margin-right: 0;
      }
    }
  }
</style>
